var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"amap",staticClass:"comAmap",style:(_vm.mapStyle)},[_c('div',{staticClass:"reset",on:{"click":_vm.handleReset}},[_c('i',{staticClass:"iconfont"},[_vm._v("")])])])}
var staticRenderFns = []

export { render, staticRenderFns }